module.exports = __webpack_public_path__ + "img/file-upload.5022453d.png";